import apiCall from "../AuthorizedApi";
import {
  ImagePurchaseTransaction,
  ImageSaleEarnings,
  PricingBreakdown,
} from "../../../Data/imagePurchase.dto";

const BASE = "/project/image-purchase";

export const getApiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  return data?.message || data?.detail || data?.error?.message || error?.message || fallback;
};

export const getPricingPreview = async (params: {
  project_id: number;
  per_image_price?: number;
}): Promise<PricingBreakdown> => {
  const res = await apiCall({
    method: "GET",
    url: `${BASE}/pricing-preview/`,
    params,
  });
  return res.data;
};

export const getImageSaleEarnings = async (params: {
  project_id?: number;
}): Promise<ImageSaleEarnings> => {
  const res = await apiCall({
    method: "GET",
    url: `${BASE}/earnings/`,
    params,
  });
  return res.data;
};

export const getImagePurchaseTransactions = async (params: {
  project_id: number;
  enrich?: 1;
}): Promise<ImagePurchaseTransaction[]> => {
  const res = await apiCall({
    method: "GET",
    url: `${BASE}/transactions/`,
    params,
  });
  const list = res?.results ?? res?.data?.results ?? res?.data ?? [];
  return Array.isArray(list) ? list : [];
};
